(function() {
	"use strict"

	angular
		.module("ATMGApi")
		.factory('AddressBook', AddressBook);

	AddressBook.$inject = ["ApiQuery", "$q", "$rootScope", "ApiCustomer", "ErrorService", "$timeout"];

 	function AddressBook( ApiQuery, $q, $rootScope, Customer, Errors, $timeout ) {

		var pagination = {
			addresses: null,
			contacts: null
		}

		// gets set when selecting an address (from my-account or during checkout)
		var currentAccountNumber = undefined;

		return {
			// @TODO what if we init it to an array?
			shippingAddresses: undefined,
			shippingContacts: undefined,
			searchMode: false,
			contactDetails: undefined,
			pagination: function() { return pagination.addresses },
			contactsPagination: function() { return  pagination.contacts },
			moduleName: "addressBook", 		//  errors module name
			error: function( msg ) {Errors.set( msg, this.moduleName ) },
			clearErrors: function() {Errors.reset( this.moduleName ) },
			loadingStack: 0,
			contact: {},
			isLoading: function() {return this.loadingStack > 0},
			loading: function() {
				var self = this;
				self.clearErrors();
				self.loadingStack += 1;
				// @TODO why are we doing this
				// after 10 seconds clear loadingStack
				$timeout(function() {self.loadingStack = 0;}, 10000);
			},
			done: function() {this.loadingStack -= 1; },
			cleanup: function() {
				this.shippingContacts = undefined;
				this.shippingAddresses = undefined;
				this.loadingStack = 0;
			},

			/**
			*	setAccountNumber
			*	account number must be set wheen adding an address
			*/
			setAccountNumber: function(accountNumber) {
				currentAccountNumber = accountNumber;
			},

			/**
			*
			*
			*/
			issetAccountNumber: function() {
				return currentAccountNumber !== undefined;
			},

			/**
			*
			*
			*/
			getAccountNumber: function() {
				if (this.issetAccountNumber) {
					return currentAccountNumber;
				}
			},

			/**
			*	addContact
			*
			*/
			addContact: function addNewContactToSelectedAddress(params) {
				if (! this.issetAccountNumber()) throw 'Current Account Number must be selected in order to create a contact.';

				var self = this,
					defer = $q.defer();

				// link new contact to current selected address' account number
				// params.account_number = this.getAccountNumber();

				self.loading()
				ApiQuery('customer/' + this.getAccountNumber() + '/contacts', params, 'POST')
					.then(function(response) {
						if (_.isNull(response.data.data)) throw 'Received an empty contact. Abort.';
						var contact = response.data.data;
						contact.person_full_name = contact.person_first_name + ' ' + contact.person_last_name;
						// init contacts list if empty
						if (!_.isArray(self.shippingContacts)) self.shippingContacts = [];
						// push it on top
						self.shippingContacts.unshift(contact)
						// returnObject.contact = contact;
						$rootScope.$broadcast("addressBook.contactAdded", contact);
					}, function(reason) {
						self.done();
						defer.reject(reason);
					})
				return defer.promise;
			},

			/**
			*	addDropShip
			*
			*/
			addDropShip: function addDropShipAddress(params) {
				var self = this,
					defer = $q.defer();

				self.loading()

				ApiQuery('customer/related-customer', params, 'POST')
					.then(function(response) {
				      	$rootScope.$emit("modal.close")
				      	$rootScope.$emit("modal.clear_error")
						let address = response.data.data.address
						let contact = response.data.data.contact

						if (! _.isArray(self.shippingAddresses)) self.shippingAddresses = [];
						// export newly created address/contact
						self.shippingAddresses.unshift(address)
						$rootScope.$broadcast("addressBook.addressAdded", {address: address, contact: contact});
					}, function(reason) {
						self.done();
						defer.reject(reason)
						if (typeof reason.data.error === 'string') {
							$rootScope.$emit("modal.error", {oracle_error: reason.data.error})
						} else {
							$rootScope.$emit("modal.error", reason.data.error)
						}

						$rootScope.$emit("modal.open", {title: 'Add new address', template: 'add_drop_ship'})
					})
				return defer.promise;
			},

			/**
			*
			* 	fetchShippingAddresses
			*
			*	fitlers format: { where: { foo: "bar" } }
			*/
			fetchShippingAddresses: function(filters, cart_id) {

				var defer = $q.defer();
				var _this = this;

				this.loading();
				// this.shippingAddresses = undefined;

				if (!_.isEmpty(filters.search)) {
					this.searchMode = true; // and we stay there
				}

				Customer.getAddresses(filters)
					.then(response => {
						this.done()
						this.shippingAddresses = response.data.data;
						if (response.data.hasOwnProperty('pagination')) {
							pagination.addresses = response.data.pagination
						}
						defer.resolve(true)
					})
					.catch(reason => {
						this.done()
						defer.reject(reason.message)
					})

				return defer.promise
			},

			/**
			*	fetchSingleShippingAddress
			*	get a single address
			*/
			fetchSingleShippingAddress: function(filters, site_use_id) {
				return new Promise((resolve, reject) => {
					// delete filters.where.site_use_id
					this.loading();
					// the account number we would add contacts to
					// this.setAccountNumber(filters.where.cust_account_role_id);
					return Customer.getAddresses(filters, site_use_id)
						.then(response => {
							this.done()
							return resolve(response.data.data)
						})
						.catch(reason =>  {
							this.done()
							return reject(reason)
						})
				})
			},

			/**
			*
			*	getShippingContacts
			*	get them all and store them locally
			*
			*	fitlers format: { where: { foo: "bar" } }
			*/
			getShippingContacts: function(relatedAccountNumber, filters) {

				var defer = $q.defer();
				var _this = this;

				this.loading();

				if (typeof filters === 'object') {
					filters.take = 100
				} else {
					filters = {take: 100}
				}

				// filters are never paginated, so just add the damn take=100 here

				// set this to be the related_account_number we use to link a new contact
				this.setAccountNumber(relatedAccountNumber);

				Customer.getContacts(relatedAccountNumber, filters)
					.then(function (response) {
						_this.done();
						_this.shippingContacts = response;
						pagination.contacts = response.pagination
						defer.resolve(true)
					}, function(reason) {
						_this.done();
						defer.reject(reason)
					})

				return defer.promise
			},

			/*
			*	fetchSingleContact
			* 	get a single one and return it
			*
			*/
			fetchSingleContact: function(relatedAccountNumber, filters) {
				var defer = $q.defer();
				this.setAccountNumber(relatedAccountNumber);
				this.loading();
				Customer.getContacts(relatedAccountNumber,  filters)
					.then((response) => {
						this.done()
						this.contact = response
						this.contactDetails = response
						return defer.resolve(this.contactDetails)
					})
					.catch(response => {
						this.done()
						return defer.reject(response.data.error)
					})
				return defer.promise;
			},

			/**
			*	turnPage
			* 	adds/removes a page from current pagination count
			*/
			turnPage: function( target, amt ) {
				var current = pagination[target].current_page,
					total = pagination[target].last_page

				if ((current + amt > 0 ) && (current + amt <= total ) ) {
					current += amt;
				}
			},

			/**
			*	goToPage
			*
			*/
			gotToPage: function( target, page ) {
				pagination[target].current_page  = page;
			}
		}
	}
})()



// WEBPACK FOOTER //
// ./src/app/modules/ATMGApi/factories/AddressBook.js